module.exports = __webpack_public_path__ + "static/media/fast.aac92d5c.gif";